import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
//icons
import { BsPencil, BsTrash } from "react-icons/bs";
import ReactLoading from "react-loading";
//configs
import { socket } from "../../configs/socket_export";
//components
import Navbar from "../components/navbar/index";
import Borderavatar from "../components/modalBorder/index";
import ModalCropUpdate from "../components/modalCropUpdate";
//context
import { useUser } from "../context/allusers";
//gif
import loading from "./assets/login_loading.gif";
import { Container, Main } from "./styles";

const Login = () => {
    const { register, handleSubmit } = useForm();

    const { getUser, setMode } = useUser();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [person, setPerson] = useState();
    const [gifLogin, setGifLogin] = useState(false);
    const [needsPassword, setNeedsPassword] = useState(false);
    const [passwordRequired, setPasswordRequired] = useState(false);
    const [authError, setAuthError] = useState("");
    const [pendingUser, setPendingUser] = useState(null);

    const [changeStatusBorder, setChangeStatusBorder] = useState();

    const rememberIsChecked = useRef();
    const autoLoginIsChecked = useRef();
    const buttonLogin = useRef();

    const sendSocketEmitStatus = (status) => {
        socket.emit("change status user", status);
    };

    const sendSocketEmitUsername = (usernameValue) => {
        socket.emit("change username user", usernameValue);
    };

    const finishSignIn = (data, userPayload) => {
        sendSocketEmitUsername(data.username);
        sendSocketEmitStatus(data.status);

        if (rememberIsChecked.current) data.remember = rememberIsChecked.current.checked;
        if (autoLoginIsChecked.current) data.autologin = autoLoginIsChecked.current.checked;

        const avatarValue = (userPayload && userPayload.avatar) || (person && person.avatar) || "";

        if (data.remember) {
            localStorage.setItem("saveUser", JSON.stringify({ username: data.username, avatar: avatarValue, autologin: autoLoginIsChecked.current.checked }));
        } else {
            localStorage.removeItem("saveUser");
        }

        if (changeStatusBorder !== "invisible") {
            socket.emit("socket connected notification", { avatar: avatarValue });
        }

        setMode("home");
    };

    const handleLogin = async (data) => {
        setGifLogin(true);
        setAuthError("");
        setPasswordRequired(false);
        if (buttonLogin.current) buttonLogin.current.disabled = true;

        if (!data.username || data.username.trim() === "") {
            setGifLogin(false);
            if (buttonLogin.current) buttonLogin.current.disabled = false;
            setAuthError("You must enter your username.");
            return;
        }

        try {
            const response = await fetch("/routes/auth/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({ username: data.username, password: data.password || "" }),
            });

            const payload = await response.json().catch(() => ({}));

            if (!response.ok) {
                if (payload.passwordRequired) {
                    setPasswordRequired(true);
                    setAuthError("Password required.");
                } else {
                    setAuthError("Unable to sign in.");
                }
                setGifLogin(false);
                if (buttonLogin.current) buttonLogin.current.disabled = false;
                return;
            }

            if (payload.needsPassword) {
                setNeedsPassword(true);
                setPasswordRequired(true);
                setPendingUser(payload.user || null);
                setGifLogin(false);
                if (buttonLogin.current) buttonLogin.current.disabled = false;
                return;
            }

            finishSignIn(data, payload.user);
        } catch (err) {
            setAuthError("Unable to connect to the server, try again!");
            setGifLogin(false);
            if (buttonLogin.current) buttonLogin.current.disabled = false;
        }
    };

    const handleSetPassword = async (data) => {
        setGifLogin(true);
        setAuthError("");
        if (buttonLogin.current) buttonLogin.current.disabled = true;

        if (!data.password || data.password.length < 6) {
            setGifLogin(false);
            if (buttonLogin.current) buttonLogin.current.disabled = false;
            setAuthError("Password must be at least 6 characters.");
            return;
        }

        try {
            const response = await fetch("/routes/auth/set-password", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({ password: data.password }),
            });

            const payload = await response.json().catch(() => ({}));
            if (!response.ok) {
                setAuthError(payload.error === "password_too_short" ? "Password must be at least 6 characters." : "Unable to set password.");
                setGifLogin(false);
                if (buttonLogin.current) buttonLogin.current.disabled = false;
                return;
            }

            setNeedsPassword(false);
            finishSignIn(data, pendingUser);
        } catch (err) {
            setAuthError("Unable to set password.");
            setGifLogin(false);
            if (buttonLogin.current) buttonLogin.current.disabled = false;
        }
    };

    const onSubmit = (data) => {
        if (needsPassword) return handleSetPassword(data);
        return handleLogin(data);
    };

    const handleCancelLogin = () => {
        setGifLogin(false);
        if (buttonLogin.current) buttonLogin.current.disabled = false;
    };

    const handleChangeUsername = (e) => {
        setUsername(e.target.value);
    };

    const handleChangePassword = (e) => {
        setPassword(e.target.value);
    };

    const handleVerifyRememberInput = () => {
        if (rememberIsChecked.current.checked) {
            autoLoginIsChecked.current.disabled = false;
        } else {
            autoLoginIsChecked.current.disabled = true;
            autoLoginIsChecked.current.checked = false;
        }
    };

    const clearSaveUser = () => {
        localStorage.removeItem("saveUser");
        setUsername("");
        setPassword("");
        rememberIsChecked.current.checked = false;
        autoLoginIsChecked.current.checked = false;
        socket.emit("change avatar", "");
        alert("Information cleared.");
    };

    (async function () {
        setPerson(await getUser(socket.id));
    })();

    useEffect(() => {
        if (localStorage.getItem("saveUser")) {
            let infos = JSON.parse(localStorage.getItem("saveUser"));
            setUsername(infos.username);
            socket.emit("change avatar", infos.avatar);
            rememberIsChecked.current.checked = true;
            autoLoginIsChecked.current.disabled = false;
            autoLoginIsChecked.current.checked = infos.autologin;
        }
    }, person);

    return (
        <Main>
            <Navbar />
            <Container>
                {person ? <Borderavatar avatar={person.avatar} size="96" status={changeStatusBorder} minus="22" top="4px" left="3px"></Borderavatar> : <ReactLoading type="spin" color="black" height={100} width={100} />}

                <ModalCropUpdate className="change-photo-button">
                    <BsPencil size={15} color="black" />
                </ModalCropUpdate>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="div-input-login">
                        <p>Username:</p>
                        <input id="login-input-email" ref={register} name="username" type="text" value={username} onChange={handleChangeUsername} />
                    </div>

                    {passwordRequired && (
                        <div className="div-input-login">
                            <p>{needsPassword ? "Set password:" : "Password:"}</p>
                            <input ref={register} name="password" type="password" value={password} onChange={handleChangePassword} />
                        </div>
                    )}

                    <div id="login-status">
                        <p>Sign in as:</p>
                        <select ref={register} name="status" onChange={(e) => setChangeStatusBorder(e.target.value)}>
                            <option value="online">Online (Default)</option>
                            <option value="busy">Busy</option>
                            <option value="away">Away</option>
                            <option value="invisible">Offline</option>
                        </select>
                    </div>
                    <div className="checkbox-buttons-login">
                        <input type="checkbox" ref={rememberIsChecked} onChange={handleVerifyRememberInput}></input>
                        <p>Remember me</p>
                        <button type="button" onClick={clearSaveUser}>
                            <BsTrash />
                        </button>
                    </div>
                    <div className="checkbox-buttons-login">
                        <input disabled type="checkbox" ref={autoLoginIsChecked}></input>
                        <p>Sign me in automatically</p>
                    </div>
                    {authError && <small style={{ color: "firebrick" }}>{authError}</small>}
                    <div id="footer-buttons">
                        {person ? (
                            <button ref={buttonLogin} type="submit">
                                {needsPassword ? "Set password" : "Sign in"}
                            </button>
                        ) : (
                            <button
                                type="button"
                                ref={buttonLogin}
                                onClick={() => {
                                    alert("Unable to connect to the server, try again!");
                                }}
                            >
                                {needsPassword ? "Set password" : "Sign in"}
                            </button>
                        )}
                    </div>
                </form>
                {gifLogin && (
                    <div id="div-gif-singin">
                        <small>{needsPassword ? "Setting password..." : "Signing in..."}</small>
                        <img src={loading} alt="gif-singin" />
                        <p onClick={handleCancelLogin}>Cancel</p>
                    </div>
                )}
            </Container>
        </Main>
    );
};

export default Login;
